/**
 * UserStatusBadge Component
 * Badge pour afficher le statut d'un utilisateur (actif/inactif/verrouillé)
 */

import { CheckCircle, XCircle, Lock } from 'lucide-react';

interface UserStatusBadgeProps {
  isActive: boolean;
  isLocked?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function UserStatusBadge({ isActive, isLocked = false, size = 'md' }: UserStatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  // Verrouillé (priorité haute)
  if (isLocked) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-full border
                  bg-danger-light text-danger border-danger font-medium
                  ${sizeClasses[size]}`}
      >
        <Lock className={iconSizes[size]} />
        Verrouillé
      </span>
    );
  }

  // Actif
  if (isActive) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-full border
                  bg-success-light text-success border-success font-medium
                  ${sizeClasses[size]}`}
      >
        <CheckCircle className={iconSizes[size]} />
        Actif
      </span>
    );
  }

  // Inactif
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border
                bg-surface-overlay text-content-muted border-border font-medium
                ${sizeClasses[size]}`}
    >
      <XCircle className={iconSizes[size]} />
      Inactif
    </span>
  );
}
